import {DroppingOddsReducer, ReducerFromState} from "../../../@types/reducers";


export const getClassicBookmaker = (state: ReducerFromState<DroppingOddsReducer>): number => state.odds.classicBookmaker;

